import React, { useEffect, useState } from 'react';
import LoadingSpinner from '../components/LoadingSpinner';
import { apiService } from '../services/apiService';
import { portalService } from '../services/portalService';

const ChildrenGrades = () => {
  const [children, setChildren]     = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const [grades, setGrades]         = useState([]);
  const [loading, setLoading]       = useState(true);
  const [gradeLoading, setGradeLoading] = useState(false);
  const [error, setError]           = useState('');

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true);
        const dashboard = await portalService.getParentDashboard();
        const kids = dashboard.children || [];
        setChildren(kids);
        if (kids.length) setSelectedId(kids[0].id);
      } catch { setError('Failed to load children.'); }
      finally { setLoading(false); }
    };
    load();
  }, []);

  useEffect(() => {
    if (!selectedId) return;
    const load = async () => {
      try {
        setGradeLoading(true);
        const data = await apiService.get(`grades/student/${selectedId}`);
        setGrades(data || []);
      } catch { setError('Failed to load grades.'); }
      finally { setGradeLoading(false); }
    };
    load();
  }, [selectedId]);

  const child = children.find(c => c.id === selectedId);
  if (loading) return <LoadingSpinner message="Loading..." />;

  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Grades {child ? `— ${child.name}` : ''}</h1>
      </div>
      {error && <div className="error-message">{error}</div>}

      {children.length > 1 && (
        <div className="form-group" style={{ maxWidth: 300, marginBottom: '1.5rem' }}>
          <label>Select Child</label>
          <select value={selectedId} onChange={e => setSelectedId(Number(e.target.value))}>
            {children.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
          </select>
        </div>
      )}

      {gradeLoading ? <LoadingSpinner message="Loading grades..." /> : (
        <div className="table-responsive">
          <table className="data-table">
            <thead>
              <tr><th>Assessment</th><th>Module</th><th>Marks</th><th>%</th><th>Remarks</th></tr>
            </thead>
            <tbody>
              {grades.length === 0 ? (
                <tr><td colSpan={5} className="no-data-message">No grades recorded yet.</td></tr>
              ) : grades.map(g => (
                <tr key={g._id}>
                  <td>{g.assessmentTitle}</td>
                  <td>{g.moduleName || g.subjectName || 'Module'}</td>
                  <td>{g.marksObtained} / {g.totalMarks}</td>
                  <td>{g.percentage ?? 0}%</td>
                  <td>{g.remarks || '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default ChildrenGrades;
